import React from 'react';
import MetaLayoutFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const Default = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <MetaLayoutFields
      resource={resource}
    />
  );
};

export { Default };
